import { render, staticRenderFns } from "./PluginSettingsShippo.vue?vue&type=template&id=1f3c9e34&"
import script from "./PluginSettingsShippo.vue?vue&type=script&lang=ts&"
export * from "./PluginSettingsShippo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports